
import UserDeleteBtn from "./UserDeleteBtn/UserDeleteBtn";
import UserEditBtn from "./UserEditBtn/UserEditBtn";
import { UserExtendInfo, UserFirstName, UserInfo, UserLastName, UserOrganizationName } from "./UserInfo/UserInfo";

export const SingleUser = {
    FirstName: UserFirstName,
    LastName: UserLastName,
    OrganizationName: UserOrganizationName,
    UserInfo: UserInfo,
    UserExtendInfo,
    DeleteUserBtn: UserDeleteBtn,
    EditUserBtn: UserEditBtn
}


export default SingleUser;